import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerProfile } from '@models/resources/customer-profile.model';

/**
 * Referenz-Facade für den FE-First-Dummy-Data-Layer (Story S1-9).
 *
 * Zwei konkrete Implementierungen:
 * - `DummyCustomerProfileFacade` – liest Fixtures mit künstlicher Latenz.
 * - `HttpCustomerProfileFacade` – Stub, bis Sprint 4 den BE-Endpoint liefert.
 *
 * Components injizieren den `CUSTOMER_PROFILE_FACADE`-Token (nicht das
 * konkrete Class-Token), so dass der Sprung `dummy → http` in Sprint 4
 * ein reiner Provider-Tausch in `app.config.ts` ist.
 *
 * Sprint 2 wird diesen Pattern 1:1 für `CustomerDepotFacade`,
 * `TransactionRequestsFacade` und `DocumentsFacade` kopieren.
 */
export interface CustomerProfileFacade {
  getProfile(): Observable<CustomerProfile>;
}

export const CUSTOMER_PROFILE_FACADE = new InjectionToken<CustomerProfileFacade>(
  'CustomerProfileFacade',
);
